module.exports = __webpack_public_path__ + "static/abusrd_design06-0385569ab753cf8f6761287f21222eaa.png";